import { Flex, Skeleton, Table, Text, Tr } from '@chakra-ui/react'
import { Td } from '@chakra-ui/table'
import { firstLetterUpperCaseAndRestLowerCase } from '../../../utils/capitalFirstLetter'

export function Summary({ data, loading, filtroPorPrazo, onClose, filtroPorEntrega }) {
  const pedidosSemDuplicados = data?.filter((item, index, self) => {
    return index === self.findIndex((t) => t.PEDIDO === item.PEDIDO)
  })

  const pedidosTerceirizados = data?.filter((item) => item.tercerizado)?.length

  const objectGravacoes = {
    Laser: 0,
    Serigrafia: 0,
    Tampografia: 0,
    Uv: 0,
    Transfer: 0,
    Silk: 0,
    Marca: 0,
    Etiqueta: 0,
    Placa: 0,
    'Sem Impressão': 0,
    DTF: 0,
    Colorida: 0,
  }

  data?.forEach((item) => {
    Object.keys(objectGravacoes).forEach((tipoGravacao) => {
      if (item.PASSO_ATUAL !== 'TÉRMINO DE PERSONALIZAÇÃO') {
        if (item.GRAVACAO.toLowerCase().includes(tipoGravacao.toLowerCase())) {
          objectGravacoes[tipoGravacao] += parseInt(item.QUANTIDADE)
        }
      }
    })
  })

  const arrayGravacoes = Object.entries(objectGravacoes)
    .map(([key, value]) => {
      return { gravacao: key, quantidade: value }
    })
    .filter((item) => item.quantidade > 0)

  const totalGravações = arrayGravacoes.reduce((acc, item) => {
    return acc + item.quantidade
  }, 0)

  const transporte = pedidosSemDuplicados?.reduce(
    (acc, item) => {
      const { ENTREGA } = item
      const wordsEntrega = ENTREGA.split(' ')
      const countEntrega = wordsEntrega.reduce((count, word) => {
        if (word.startsWith('Transportadora') || word.startsWith('transportadora') || word.startsWith('TRANSPORTADORA')) {
          return { ...count, transportadora: (count.transportadora || 0) + 1 }
        } else if (word.startsWith('Nosso') || word.startsWith('nosso') || word.startsWith('NOSSO')) {
          return { ...count, nosso: (count.nosso || 0) + 1 }
        } else if (word.startsWith('Cliente') || word.startsWith('cliente') || word.startsWith('CLIENTE')) {
          return { ...count, cliente: (count.cliente || 0) + 1 }
        } else if (word.startsWith('Motoboy') || word.startsWith('motoboy') || word.startsWith('MotoBoy')) {
          return { ...count, motoboy: (count.motoboy || 0) + 1 }
        }

        return count
      }, {})

      return {
        transportadora: (acc.transportadora || 0) + (countEntrega.transportadora || 0),
        nosso: (acc.nosso || 0) + (countEntrega.nosso || 0),
        cliente: (acc.cliente || 0) + (countEntrega.cliente || 0),
        motoboy: (acc.motoboy || 0) + (countEntrega.motoboy || 0),
        total: (acc.total || 0) + 1,
      }
    },
    {
      transportadora: 0,
      nosso: 0,
      cliente: 0,
      motoboy: 0,
      total: 0,
    }
  )

  const counterNumPed = data?.filter((item, index, self) => self.findIndex((t) => t.PEDIDO === item.PEDIDO) === index)

  const listPrazos = counterNumPed?.reduce((acc, item) => {
    const { PRAZO } = item

    return {
      ...acc,
      [PRAZO]: (acc[PRAZO] || 0) + 1, // aqui estou somando a quantidade de prazos iguais
      total: (acc.total || 0) + 1, // aqui estou somando a quantidade total de prazos
    }
  }, {})

  const arrayPrazos = Object.entries(listPrazos).map(([key, value]) => {
    return { prazo: key, quantidade: value }
  })

  console.log('listPrazos: ', arrayPrazos)

  function handleFilterByPrazo(prazo) {
    filtroPorPrazo(prazo)
    onClose()
  }

  function handleFilterByEntrega(entrega) {
    filtroPorEntrega(entrega)
    onClose()
  }

  return (
    <Flex alignItems={'flex-start'} gap={5}>
      <Flex alignItems={'flex-start'} gap={5}>
        <Flex flexDir={'column'} alignItems={'flex-start'} paddingBlock={'16px'}>
          <Text bg={'#378BBF'} paddingBlock={'11px'} paddingInline={'36px'} fontWeight={'bold'} color={'#fff'} width={'100%'} mb={2}>
            Gravações
          </Text>
          {arrayGravacoes.map((item, index) => (
            <Flex
              width={'100%'}
              key={index}
              alignItems={'center'}
              justifyContent={'space-between'}
              bg={index % 2 === 0 ? '#F5F5F5' : '#FFFFFF'}
              paddingBlock={'4px'}
              paddingInline={'36px'}
            >
              <Text fontWeight={'bold'}>{item.gravacao}:</Text>
            </Flex>
          ))}
        </Flex>
        <Flex
          flexDir={'column'}
          alignItems={'flex-start'}
          boxShadow={'0px 3px 6px #00000029'}
          paddingInline={'16px'}
          paddingBlock={'16px'}
          borderRadius={'2px'}
          overflow={'hidden'}
        >
          <Text bg={'#378BBF'} paddingBlock={'11px'} paddingInline={'36px'} fontWeight={'bold'} color={'#fff'} width={'100%'} mb={2}>
            Quantidade
          </Text>
          {arrayGravacoes.map((item, index) => (
            <Flex
              width={'100%'}
              key={index}
              alignItems={'center'}
              justifyContent={'center'}
              bg={index % 2 === 0 ? '#F5F5F5' : '#FFFFFF'}
              paddingBlock={'4px'}
            >
              <Text>{item.quantidade}</Text>
            </Flex>
          ))}
          <Text
            bg={'#378BBF'}
            paddingBlock={'11px'}
            fontWeight={'bold'}
            color={'#fff'}
            width={'100%'}
            textAlign={'center'}
            //deixar pro baixo da borda
          >
            {totalGravações}
          </Text>
        </Flex>
      </Flex>
      <Flex flexDir={'column'} paddingBlock={'16px'}>
        <Text bg={'#378BBF'} paddingBlock={'11px'} paddingInline={'36px'} fontWeight={'bold'} color={'#fff'} width={'100%'} mb={2}>
          Total de pedidos
        </Text>
        <Flex width={'100%'} alignItems={'center'} justifyContent={'center'} paddingBlock={'4px'} bg={'#F5F5F5'}>
          <Text fontWeight={'bold'}>{pedidosSemDuplicados?.length}</Text>
        </Flex>
      </Flex>

      <Flex flexDir={'column'} paddingBlock={'16px'}>
        <Text bg={'#378BBF'} paddingBlock={'11px'} paddingInline={'36px'} fontWeight={'bold'} color={'#fff'} width={'100%'} mb={2}>
          Pedidos Terceirizados
        </Text>
        <Flex width={'100%'} alignItems={'center'} justifyContent={'center'} paddingBlock={'4px'} bg={'#F5F5F5'}>
          <Text fontWeight={'bold'}>{pedidosTerceirizados || 0}</Text>
        </Flex>
      </Flex>

      <Flex flexDir={'column'} paddingBlock={'16px'}>
        <Text bg={'#378BBF'} paddingBlock={'11px'} paddingInline={'36px'} fontWeight={'bold'} color={'#fff'} width={'100%'} mb={2}>
          Tipo de entrega
        </Text>
        <Flex
          width={'100%'}
          alignItems={'center'}
          justifyContent={'space-between'}
          paddingBlock={'4px'}
          bg={'#F5F5F5'}
          paddingInline={'36px'}
          gap={2}
        >
          <Text>Cliente retira: </Text>
          <Text
            fontWeight={'bold'}
            cursor={'pointer'}
            _hover={{ textDecoration: 'underline' }}
            onClick={() => {
              handleFilterByEntrega('cliente')
            }}
          >
            {transporte?.cliente}
          </Text>
        </Flex>

        <Flex width={'100%'} alignItems={'center'} justifyContent={'space-between'} paddingBlock={'4px'} bg={'#fff'} gap={2} paddingInline={'36px'}>
          <Text>Transportadora: </Text>
          <Text
            fontWeight={'bold'}
            cursor={'pointer'}
            _hover={{ textDecoration: 'underline' }}
            onClick={() => {
              handleFilterByEntrega('transportadora')
            }}
          >
            {transporte?.transportadora}
          </Text>
        </Flex>
        <Flex
          width={'100%'}
          alignItems={'center'}
          justifyContent={'space-between'}
          paddingBlock={'4px'}
          paddingInline={'36px'}
          bg={'#F5F5F5'}
          gap={2}
        >
          <Text>Nosso Carro: </Text>
          <Text
            fontWeight={'bold'}
            cursor={'pointer'}
            _hover={{ textDecoration: 'underline' }}
            onClick={() => {
              handleFilterByEntrega('nosso')
            }}
          >
            {transporte?.nosso}
          </Text>
        </Flex>
        <Flex width={'100%'} alignItems={'center'} justifyContent={'space-between'} paddingBlock={'4px'} paddingInline={'36px'} bg={'#fff'} gap={2}>
          <Text>Motoboy: </Text>
          <Text
            fontWeight={'bold'}
            cursor={'pointer'}
            _hover={{ textDecoration: 'underline' }}
            onClick={() => {
              handleFilterByEntrega('motoboy')
            }}
          >
            {transporte?.motoboy}
          </Text>
        </Flex>
        <Flex
          width={'100%'}
          alignItems={'center'}
          justifyContent={'space-between'}
          paddingBlock={'4px'}
          paddingInline={'36px'}
          bg={'#F5F5F5'}
          gap={2}
        >
          <Text>Total: </Text>
          <Text fontWeight={'bold'}>{transporte?.total}</Text>
        </Flex>
      </Flex>

      <Flex flexDir={'column'} paddingBlock={'16px'}>
        <Text bg={'#378BBF'} paddingBlock={'11px'} paddingInline={'36px'} fontWeight={'bold'} color={'#fff'} width={'100%'} mb={2}>
          Prazos
        </Text>
        {arrayPrazos.map((item, index) => (
          <Flex
            width={'180px'}
            key={index}
            alignItems={'center'}
            justifyContent={'space-between'}
            bg={index % 2 === 0 ? '#F5F5F5' : '#FFFFFF'}
            paddingBlock={'4px'}
            paddingInline={'36px'}
          >
            <Text>
              {firstLetterUpperCaseAndRestLowerCase(item.prazo)} {item.prazo !== 'total' && `dia${Number(item.prazo) > 1 ? 's' : ''}`}:
            </Text>
            <Text
              fontWeight={'bold'}
              cursor={'pointer'}
              _hover={{ textDecoration: 'underline' }}
              onClick={() => {
                handleFilterByPrazo(item.prazo)
              }}
            >
              {item.quantidade}
            </Text>
          </Flex>
        ))}
      </Flex>
    </Flex>
  )
}
